<template>
    <tr class="document-allocations normal-wrap">
        <td class="left-border" :colspan="multiple_contractors ? 12 : 11">
            {{ __('date') }}: <strong>{{ allocation.date }}</strong> |
            {{ __('contractor') }}: <strong><truncated-text :text="allocation.contractor" :max_length="100"/></strong> |
            {{ __('payment_source_name') }}: <strong>{{ allocation.payment_source_name }}</strong> |
            {{ __('description') }}: <strong>{{ allocation.description }}</strong> |
            {{ __('amount') }}: <strong>{{ allocation.amount }}</strong> |
            {{ __('currency') }}: <strong>{{ allocation.currency }}</strong>
            <span v-show="!allocation.is_generated_balance">
                                | {{ __('allocated') }}: <strong>{{ allocation.allocated }}</strong> |
                                {{ __('currency') }}: <strong>{{ allocation.allocated_currency }}</strong>
                                </span>
        </td>
        <td class="text-right table-icons">

            <a v-show="allocation.is_generated_balance && controls.includes('destroy')"
               @click="destroy(allocation)"
               :title="__('delete')"
               :data-original-title="__('delete')"
               class="icon-delete" data-toggle="tooltip" data-placement="top">
                <i class="fa fa-trash"></i>
            </a>

            <a v-show="!allocation.is_generated_balance && controls.includes('show')" @click="checkAvaibleForCashRegister(document, $event)"
               :href="showUrl(allocation)"
               :title="__('show')"
               :data-original-title="__('show')"
               data-toggle="tooltip" data-placement="top" >
                <i class="fa fa-eye"></i>
            </a>

            <a v-show="!allocation.is_generated_balance && controls.includes('edit')" @click="checkAvaibleForCashRegister(document, $event)"
               :href="editUrl(allocation)"
               :title="__('edit')"
               :data-original-title="__('edit')"
               data-toggle="tooltip" data-placement="top">
                <i class="fa fa-pen"></i>
            </a>

            <a v-show="!allocation.is_generated_balance && controls.includes('history')"
               :href="allocation.history_url"
               :title="__('goto_contractor_history')"
               :data-original-title="__('goto_contractor_history')"
               data-toggle="tooltip" data-placement="top">
                <i class="fas fa-share"></i>
            </a>
        </td>
    </tr>
</template>

<script>
    import hasTooltips from './../../../mixins/hasTooltips.js'

    export default {
        name: "OperationAllocationsDetailsRow",
        mixins: [hasTooltips],
        methods: {
            destroy: function(allocation) {
                var self = this;
                swal({
                        title: $.i18n._("delete_record_?"),
                        text: $.i18n._('it_will_not_be_possible_to_retrieve_it_later_!'),
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#d9534f",
                        confirmButtonText: $.i18n._("delete"),
                        cancelButtonText: $.i18n._("cancel"),
                        closeOnConfirm: true
                    },
                    function (result) {
                        if(result) {
                            self.$emit('destroy', allocation);
                        }
                    }
                );
            },
            checkAvaibleForCashRegister: function(document, event) {
                if (!document.cash_register_for_department) {
                    event.preventDefault()
                    swal({
                        title: this.__("the_source_cash_register_department_has_been_hidden"),
                        icon: "warning",
                        confirmButtonText: $.i18n._("close"),
                        closeOnConfirm: true,
                    })
                } else if (!document.cash_register_for_user) {
                    event.preventDefault();
                    swal({
                        title: this.__("no_authorization_for_the_source_cash_register"),
                        icon: "warning",
                        confirmButtonText: $.i18n._("close"),
                        closeOnConfirm: true,
                    })
                }
            },
            editUrl: function (allocation) {
                return allocation.is_department_transfer ? allocation.edit_url + '&return=' + location : allocation.edit_url + '?return=' + location
            },
            showUrl: function (allocation) {
                return allocation.is_department_transfer ? allocation.show_url + '&return=' + location : allocation.show_url + '?return=' + location
            },
        },
        props: {
            allocation: {
                type: Object,
                required: true
            },
            document : {
                default: false
            },
            multiple_contractors: {
                type: Boolean,
                required: false,
                default: false
            },
            controls: {
                type: Array,
                required: false,
                default: () => ['destroy', 'show', 'edit']
            }
        },
        computed: {
            location: function () {
                return location.pathname
            },
        }
    }

</script>

<style scoped>

</style>
